<template>
<div class="header-container" v-bind:class="{'scrollactive': bgActive}">
    <div class="wrapper">
        <div class="image-container">
            <a href="/"><img src="../../assets/newlogo.png"></a>
        </div>
        <div class="right-container">
            <div class="nav">
                <ul>
                    <li v-for="item in routes" :key="item.name">
                        <router-link :to="item.path">
                            <div v-if="item.name == '产品'" class="product-expand">
                                <el-dropdown>
                                    <span class="el-dropdown-link">
                                        产品<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-bind:style="{fontWeight: 'bold',color: '#272727'}" disabled>
                                            企业基本面
                                        </el-dropdown-item>

                                        <el-dropdown-item v-for="subItem in productRoutes" :key="subItem.name">
                                            <router-link :to="subItem.path">
                                                {{subItem.name}}
                                            </router-link>
                                        </el-dropdown-item>
 
                                        <el-dropdown-item divided></el-dropdown-item>
                                        <el-dropdown-item v-bind:style="{fontWeight: 'bold',color: '#272727'}" disabled>量化因子</el-dropdown-item>
                                        <el-dropdown-item v-for="subItemB in emotionRoutes" :key="subItemB.name">
                                            <router-link :to="subItemB.path">
                                                {{subItemB.name}}
                                            </router-link>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <div v-else-if="item.name == '文档'" class="product-expand">
                                <el-dropdown>
                                    <span class="el-dropdown-link">
                                        文档<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="item in fileRoutes" :key="item.name">
                                            <router-link :to="item.path">
                                                {{ item.name }}
                                            </router-link>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <span v-else>
                                {{item.name}}
                            </span>
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="bts">
                <!-- 未登录之前 -->
                <div class="login-container" v-if="!hasLogin">
                    <div class="login" @click="login">登录</div>
                    <!-- <div class="sign-up" @click="signUp">注册</div> -->
                </div>
                <!-- 登陆之后 -->
                <div class="login-after">
                    <el-dropdown v-if="hasLogin" @command="handleCommand">
                        <span class="el-dropdown-link">
                        个人中心
                        <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="userInfo">
                            <i class="fa fa-user info-weight"></i>用户资料
                        </el-dropdown-item>
                        <el-dropdown-item command="pay">
                            <i class="fa fa-cny info-weight"></i>账户充值
                        </el-dropdown-item>
                        <el-dropdown-item command="customization">
                            <i class="fa fa-book info-weight"></i>数据定制
                        </el-dropdown-item>
                        <!--<el-dropdown-item command="dataAudit">
                            <i class="fa fa-cog info-weight"></i>数据审计
                        </el-dropdown-item>-->
                        <el-dropdown-item command="logout">
                            <i class="fa fa-sign-out info-weight"></i>注销
                        </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
    </div>
</div>

</template>
<script>
  import {mapState, mapMutations} from 'vuex'
  import {CHANGE_USER_STATUS, SET_USER_MESSAGE} from '@/store/mutation-types'
  import {logout} from '@/services/getData'
  import { clearStore } from '@/utils/localStorage'

  export default {
    data() {
        return{
            routes: [{
            path: '/', name: '首页'
            }, {
            path: '', name: '产品'
            }, {
            path: '/service', name: '解决方案'
            }, {
            path: '', name: '文档'
            }, {
            path: '/recurit', name: '加入我们'
            }],
            productRoutes: [
                {
                    path: '/direction',
                    name: '品牌数据库'
                },{
                    path: '/direct/ocs',
                    name: '中概股企业'
                },{
                    path: '/direct/unlisted',
                    name: '未上市企业'
                }
            ],
            emotionRoutes: [
                {
                    path: '/emotion',
                    name: '情绪因子'
                }
            ],
            fileRoutes:[
                {
                    path:'/document',
                    name:'API文档'
                },{
                    path:'/dataDownload',
                    name:'数据下载'
                },{
                    path:'/newproduct',
                    name:'大模型产品'
                },{
                    path:'/Aindex',
                    name:'全A指数'
                }
            ],
            bgActive: false,
            urlPath: '',//监听路由
        }
    },
    computed: mapState(['hasLogin', 'token']),
    methods: {
      ...mapMutations([CHANGE_USER_STATUS, SET_USER_MESSAGE]),
      login () {
        this.$router.push('login');
      },
      signUp () {
        this.$router.push('signup');
      },
      async logOut () {
        try {
          let hasLogOut = await logout()
          if (hasLogOut) {
            this.$cookie.delete('user_id')
            this.$cookie.delete('token')
            this.CHANGE_USER_STATUS(false)
            this.SET_USER_MESSAGE({user_id: undefined, token: undefined, username: undefined})
            clearStore()
            this.$router.push({path: '/'})
          }
        } catch (error) {
          this.$cookie.delete('user_id')
          this.$cookie.delete('token')
          this.CHANGE_USER_STATUS(false)
          this.SET_USER_MESSAGE({user_id: undefined, token: undefined, username: undefined})
          clearStore()
          this.$router.push({path: '/'})
        }
      },
      handleCommand (command) {
        if (command === 'logout') this.logOut()
        else this.$router.push({path: '/' + command})
      },
      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if(scrollTop < 70 && this.urlPath == '/') {
            this.bgActive = false;
        }
        else {
            this.bgActive = true;
        }
      },
    },
    mounted() { 
        window.addEventListener('scroll', this.handleScroll);
        if (this.$cookie.get('token')) this.CHANGE_USER_STATUS(true)
        else if (this.token) this.CHANGE_USER_STATUS(true)
        else this.CHANGE_USER_STATUS(false)
    },
    watch: {
        $route(to, from) {
                this.urlPath = to.path;
                if(this.urlPath !== '/') {
                    this.bgActive = true;
                } else {
                    this.bgActive = false;
                }
        }
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../styles/mixins';
  @import '../../styles/constants';

  .scrollactive {
      background-color: #5387BD;
      opacity: 1;
  }
  .header-container{
      position: fixed;
      width: 100%;
      height: 88px;
      top: 0;
      transition: background-color 1s linear;
      z-index: 99;
    .wrapper {
      width: 1200px;
      height: 88px;
      position: fixed;
      top: 0;
      left: 50%;
      margin-left: -600px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      //background-color: #2f6eb8;
      .image-container{
        // padding-top: 18px;
        // padding-left: 45px;
        a {
          img {
            width: 145px;
            height: 49px;
            margin-top: 19.5px;
          }
        }
      }
      .right-container{
          display: flex;
        .nav {
            margin: 20px 0 0 266px;
            ul {
            width: 480px;
            margin: 0;
            padding: 0;
            li {
                list-style: none;
                float: left;
                width: 80px;
                text-align: center;
                a {
                    text-decoration: none;
                    width: 33px;
                    height: 17px;
                    font-family: 'MicrosoftYaHei';
                    color: #fff;
                    font-size: 16px;
                    line-height: 48px;
                }
                .product-expand {
                    .el-dropdown-link {
                    width: 33px;
                    height: 17px;
                    font-family: 'MicrosoftYaHei';
                    color: #fff;
                    font-size: 16px;
                    line-height: 48px; 
                    }                
                }
            }
            }
        }
        .bts {
            .login-container{
                margin: 20px 0 0 0;
                display: flex;
                flex-direction: row;
                font-size: 16px;
                line-height: 48px;
                color: #fff;
                .login{
                    cursor: pointer;
                    width: 80px;
                    height: 17px;
                    font-size: 16px;
                    line-height: 48px;
                    text-align: center;
                    &::before {
                        content: url("../../assets/login.png");
                        margin-right: .5rem;
                        vertical-align: middle;
                    }
                }
                .sign-up{
                    cursor: pointer;
                    width: 80px;
                    height: 17px;
                    font-size: 16px;
                    line-height: 48px;
                    text-align: center;
                    &::before {
                        content: url("../../assets/sign.png");
                        margin-right: .5rem;
                        vertical-align: middle;
                    }
                }
            }
            .login-after {
                margin: 20px 0 0 0;
                width: 140px;
                height: 17px;
                text-align: center;
                font-size: 16px;
                line-height: 48px;
                .el-dropdown-link {
                    display: block;
                    width: 150px;
                    color: #fff;
                    font-size: 16px;
                    i {
                        display: inline;
                    }
                }
            }
        }
      }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/header/newHeader.vue